"use strict";

exports.__esModule = true;
exports.NotificationContext = void 0;
exports.NotificationSupplier = NotificationSupplier;
var _react = _interopRequireDefault(require("react"));
var _Core = require("../../Core");
var _NotificationComponents = require("../NotificationComponents");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var NotificationContext = exports.NotificationContext = /*#__PURE__*/_react["default"].createContext({});
function NotificationSupplier(props) {
  var _React$useState = _react["default"].useState([]),
    notifications = _React$useState[0],
    setNotifications = _React$useState[1];
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    intl = _React$useContext.intl;
  var consumerProps = {
    showNotification: function showNotification(type, params) {
      if (Object.prototype.hasOwnProperty.call(_NotificationComponents.notificationComponents, type)) {
        return _NotificationComponents.notificationComponents[type](intl, params);
      }
      return null;
    },
    notifications: notifications,
    addNotification: function addNotification(notification) {
      return setNotifications(notifications.push(notification));
    }
  };
  return /*#__PURE__*/_react["default"].createElement(NotificationContext.Provider, {
    value: consumerProps
  }, props.children);
}